import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { selectProductsArray } from 'services/products/selectors';
import { AppState } from 'services/types';
import { SprayProductTypeId } from 'services/productTypes/types';
import { Product } from 'services/products/types';
import { OwnProps } from './index';

const selectSprayProductTypeId = (
    state: AppState,
    props: OwnProps
): SprayProductTypeId => props.sprayProductTypeId;

const makeSelectOptions = (): any =>
    createDeepEqualSelector(
        selectProductsArray,
        selectSprayProductTypeId,
        (productsState, sprayProductTypeIdProp) => {
            const options: Record<string, any> = [];

            productsState &&
                productsState.forEach((item: Product) => {
                    const { id, name, sprayProductTypeId, deletedAt } = item;

                    if ( !deletedAt &&
                        (
                            !sprayProductTypeIdProp ||
                            sprayProductTypeIdProp === sprayProductTypeId
                        )
                    ) {
                        options.push({
                            key: id,
                            text: name,
                            value: id
                        });
                    }
                });

            return options;
        }
    );

export { makeSelectOptions };
